<template>
  <div>
    <div class="content">
      <div class="form-container">
        <div class="vcore_container">
          <div class="vcore_row">
            <div class="vcore_col--xs--12">
              <LogoDisplay :logo-src="logo"></LogoDisplay>
              <h2 class="form-title" tabindex="-1">
                Thank you for applying for a CommerceCare<span class="sup">&reg;</span> line of credit.
              </h2>
              <div class="form-description">
                After careful consideration, we are unable to approve your
                application at this time. You will receive written notification
                with the reasons for the decision. If you have further questions
                once you receive the letter, please call us at the number
                listed.
                <br /><br />
                Thank you for considering Commerce Bank.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import LogoDisplay from "../components/LogoDisplay";
import { KEYS, getCustomBrandingByKey } from "@Shared/utils/CustomBranding";

export default {
  name: "Success",
  beforeRouteLeave(to, from, next) {
    if (to.name === "Agreement") {
      this.$emit("goHome");
    } else {
      next();
    }
  },
  components: {
    LogoDisplay
  },
  computed: {
    ...mapGetters(["institution"]),
    logo() {
      return getCustomBrandingByKey(
        KEYS.CMC_LOGO,
        this.institution.cstmBrandingList
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.sup {
    font-size: 70%;
    vertical-align: super;
}
.content {
  border: 1px solid #d3d6de;
  border-top: 0;
  padding: 40px 35px;
  background-color: #ffffff;
  box-shadow: 0 2px 14px 0 rgba(119, 151, 178, 0.23);
  z-index: -1;
  margin-bottom: 20px;
  min-height: 635px;

  @media (max-width: $grid-breakpoint-sm) {
    margin-left: auto;
    margin-right: auto;
    padding-left: 0;
    padding-right: 0;
    width: 85%;
    margin-bottom: 0;
    min-height: 0;
    border: none;
    box-shadow: none;
  }
}

.form-description {
  line-height: 22px;
}

.logo-display {
  display: none;

  @media (max-width: $grid-breakpoint-md) {
    display: inline-block;
    margin-bottom: 25px;
  }
}
</style>
